import { HTTP, HTTP_API_V2 } from '../../http-common'

export default {
  state: {
    loadedBatches: [],
    loadedBatchesV2: []
  },
  getters: {
    loadedBatches (state) {
      return state.loadedBatches
    },
    loadedBatchesV2 (state) {
      return state.loadedBatchesV2
    }
  },
  mutations: {
    setLoadedBatches (state, payload) {
      state.loadedBatches = payload
    },
    setLoadedBatchesV2 (state, payload) {
      const retroCompatibleBatchResult = payload.map(batch => {
        const finalDate = new Date(batch.final_date)
        const finalHour = `${finalDate.getUTCHours().toString().padStart(2, '0')}:${finalDate.getUTCMinutes().toString().padStart(2, '0')}`
        return {
          id: batch.id,
          batch_number: batch.identifier,
          device: {
            ...batch.barn.devices[0],
            mac: batch.barn.devices[0].identifier_value
          },
          initial_date: new Date(batch.initial_date).toISOString().replace(/[:|.|-]/g, '-').substring(0, 10),
          final_date: batch.status !== 'closed' ? '' : finalDate.toISOString().replace(/[:|.|-]/g, '-').substring(0, 10),
          initial_hour: batch.initial_hour ? batch.initial_date.toTimeString() : '00:00',
          final_hour: batch.status !== 'closed' ? '' : finalHour,
          quantity_housed: batch.quantity_housed,
          sex: batch.sex || null,
          genetics: batch.genetics || null,
          state: batch.status === 'closed' ? 'closed' : 'opened'
        }
      })
      state.loadedBatchesV2 = retroCompatibleBatchResult
    },
    createBatch (state, payload) {
      state.loadedBatches.push(payload)
    },
    createBatchV2 (state, payload) {
      const initialDate = new Date(payload.initial_date)
      const finalDate = new Date(payload.final_date)
      const initialHour = `${initialDate.getUTCHours().toString().padStart(2, '0')}:${initialDate.getUTCMinutes().toString().padStart(2, '0')}`
      const finalHour = `${finalDate.getUTCHours().toString().padStart(2, '0')}:${finalDate.getUTCMinutes().toString().padStart(2, '0')}`
      const retroCompatibleBatch = {
        ...payload,
        batch_number: payload.identifier,
        device: {
          ...payload.barn.devices[0],
          mac: payload.barn.devices[0].identifier_value
        },
        initial_date: initialDate.toISOString().replace(/[:|.|-]/g, '-').substring(0, 10),
        final_date: payload.status !== 'closed' ? '' : finalDate.toISOString().replace(/[:|.|-]/g, '-').substring(0, 10),
        initial_hour: initialHour,
        final_hour: payload.status !== 'closed' ? '' : finalHour,
        quantity_housed: payload.quantity_housed,
        state: payload.status === 'closed' ? payload.status : 'opened'
      }
      state.loadedBatchesV2.push(retroCompatibleBatch)
    },
    updateBatch (state, payload) {
      state.loadedBatches = state.loadedBatches.map(batch => batch.id === payload.id ? payload : batch)
    },
    updateBatchV2 (state, payload) {
      state.loadedBatchesV2 = state.loadedBatchesV2.map(batch => batch.id === payload.id ? payload : batch)
    },
    removeBatch (state, id) {
      state.loadedBatches = state.loadedBatches.filter(batch => {
        return batch.id !== id
      })
    },
    removeBatchV2 (state, id) {
      state.loadedBatchesV2 = state.loadedBatchesV2.filter(batch => {
        return batch.id !== id
      })
    },
    clearLoadedBatches (state) {
      state.loadedBatches = []
    },
    clearLoadedBatchesV2 (state) {
      state.loadedBatchesV2 = []
    }
  },
  actions: {
    loadBatches ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedBatches', [])

      return new Promise((resolve, reject) => {
        HTTP.get(payload ? `batch.json/?search=${payload}` : 'batch.json')
          .then(result => {
            commit('setLoadedBatches', result.data)
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    loadBatchesV2 ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedBatchesV2', [])
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get(`batches?barnId=${payload}`)
          .then(result => {
            commit('setLoadedBatchesV2', result.data)
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createBatch ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const newBatch = {
        batch_number: payload.batch_number,
        device: payload.device,
        initial_date: payload.initial_date,
        initial_hour: payload.initial_hour,
        quantity_housed: payload.quantity_housed,
        state: payload.state
      }
      return new Promise((resolve, reject) => {
        HTTP.post('batch.json/', newBatch)
          .then(result => {
            commit('createBatch', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createBatchV2 ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const retroCompatibleBatch = {
        ...payload,
        identifier: payload.batch_number,
        status: (payload.state.value === 'closed' || payload.state === 'closed') ? 'closed' : 'in_progress',
        barn: {
          ...payload.barn
        },
        final_date: payload.initial_date
      }
      return new Promise((resolve, reject) => {
        HTTP_API_V2.post('batches', retroCompatibleBatch)
          .then(result => {
            commit('createBatchV2', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateBatch ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const batch = {
        batch_number: payload.batch_number,
        device: payload.device,
        initial_date: payload.initial_date,
        final_date: payload.final_date,
        initial_hour: payload.initial_hour,
        final_hour: payload.final_hour,
        quantity_housed: payload.quantity_housed,
        state: payload.state
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`batch.json/${payload.id}/`, batch)
          .then(result => {
            commit('updateBatch', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateBatchV2 ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      const retroCompatibleBatch = {
        id: payload.id,
        identifier: payload.batch_number,
        status: (payload.state.value === 'closed' || payload.state === 'closed') ? 'closed' : 'in_progress',
        quantity_housed: payload.quantity_housed,
        initial_date: payload.initial_date,
        final_date: payload.final_date,
        initial_hour: payload.initial_hour,
        final_hour: payload.final_hour,
        sex: payload.sex || null,
        genetics: payload.genetics || null
      }
      return new Promise((resolve, reject) => {
        HTTP_API_V2.put(`batches/${payload.id}`, retroCompatibleBatch)
          .then(result => {
            const initialDate = new Date(result.data.initial_date)
            const finalDate = new Date(result.data.final_date)
            const initialHour = `${initialDate.getUTCHours().toString().padStart(2, '0')}:${initialDate.getUTCMinutes().toString().padStart(2, '0')}`
            const finalHour = `${finalDate.getUTCHours().toString().padStart(2, '0')}:${finalDate.getUTCMinutes().toString().padStart(2, '0')}`
            const retroCompatibleBatch = {
              id: result.data.id,
              batch_number: result.data.identifier,
              device: {
                ...result.data.barn.devices[0],
                mac: result.data.barn.devices[0].identifier_value
              },
              initial_date: initialDate.toISOString().replace(/[:|.|-]/g, '-').substring(0, 10),
              final_date: result.data.status !== 'closed' ? '' : finalDate.toISOString().replace(/[:|.|-]/g, '-').substring(0, 10),
              initial_hour: initialHour,
              final_hour: result.data.status !== 'closed' ? '' : finalHour,
              quantity_housed: result.data.quantity_housed,
              sex: result.data.sex || null,
              genetics: result.data.genetics || null,
              state: result.data.status === 'closed' ? result.data.status : 'opened'
            }
            commit('updateBatchV2', retroCompatibleBatch)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeBatch ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`batch.json/${payload}`)
          .then(result => {
            commit('removeBatch', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeBatchV2 ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP_API_V2.delete(`batches/${payload}`)
          .then(result => {
            commit('removeBatchV2', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedBatches ({ commit }) {
      commit('clearLoadedBatches')
    },
    clearLoadedBatchesV2 ({ commit }) {
      commit('clearLoadedBatchesV2')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/batch/index.js